/**
 * ModeToggleButtons - Site/System mode toggle buttons
 *
 * Switches between Site mode (polygon/obstruction editing) and System mode (module placement).
 */

import React from 'react';

interface ModeToggleButtonsProps {
  editMode: 'site' | 'system';
  onSiteMode: () => void;
  onSystemMode: () => void;
}

export function ModeToggleButtons({
  editMode,
  onSiteMode,
  onSystemMode,
}: ModeToggleButtonsProps) {
  return (
    <div className="p-4 border-b-2 border-gray-200 bg-gray-50">
      <div className="flex gap-2">
        <button
          onClick={onSiteMode}
          className={`flex-1 py-3 px-4 rounded-lg font-semibold text-sm transition-all ${
            editMode === 'site'
              ? 'bg-[#EBFD03] text-black border-2 border-black shadow-md'
              : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-gray-400'
          }`}
        >
          🏗️ SITE MODE
        </button>
        <button
          onClick={onSystemMode}
          className={`flex-1 py-3 px-4 rounded-lg font-semibold text-sm transition-all ${
            editMode === 'system'
              ? 'bg-blue-500 text-white border-2 border-black shadow-md'
              : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-gray-400'
          }`}
        >
          ⚡ SYSTEM MODE
        </button>
      </div>
      <p className="text-xs text-gray-600 mt-2 text-center">
        {editMode === 'site'
          ? 'Edit polygon & obstructions'
          : 'Place & arrange solar modules'}
      </p>
    </div>
  );
}

export default ModeToggleButtons;
